<template>
  <div>
    <zonglan   > </zonglan> 
    <!-- mac_manage_flag 用于下级页面接收的参数 -->
  </div>
</template>
<script>
import zonglan from '../tongyong/zonglan.vue';
 
export default {

  components: {
    zonglan: zonglan 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
